var _path, _path2, _path3, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFirst(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 148,
    viewBox: "0 0 69 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1929 104.581C30.3264 104.627 30.4441 104.664 30.58 104.703C33.4429 105.514 68.9998 115.195 69 95.6647C69.0002 75.3148 56.0021 59.6635 33.3877 59.8009L27.9281 59.8342C12.8517 59.9257 2.63551 75.0505 0.784973 85.3365C-1.06557 95.6225 -0.00848389 102.536 7.92352 103.593C15.8555 104.65 30.3973 100.422 28.5465 96.4576C26.6957 92.4933 8.71672 93.5504 8.34207 93.5251C7.96741 93.4998 9.24737 91.619 10.3779 91.6122C11.5085 91.6053 12.4308 92.4505 12.4371 93.5002L12.7102 138.211C12.7325 141.855 15.2092 145.06 18.7947 145.712C24.3478 146.721 30.0914 147.234 35.9695 147.198C39.7046 147.176 43.1434 146.932 46.5655 146.482C50.3623 145.982 53.0501 142.625 53.0257 138.795L52.7663 98.0871C52.7589 96.8629 53.6674 95.6726 54.9866 95.6647C55.5718 95.6611 56.8374 96.1932 56.8374 97.5146C56.8374 98.8361 36.2141 94.8718 28.5465 92.7576C20.9299 90.6574 20.0966 101.074 30.1929 104.581Z",
    fill: "#5C4691"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28997 24.6441C8.10349 39.2173 18.7904 51.8399 33.1604 52.8373C47.5303 53.8345 60.8281 42.8251 62.0149 28.2518C63.2016 13.6785 51.8279 1.06018 37.458 0.0627797C23.0881 -0.934622 10.477 10.0708 9.28997 24.6441Z",
    fill: "#5C4691"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1027 41.7933C38.7123 44.5147 34.725 45.5888 33.0403 45.5364C30.8265 45.4676 28.8608 45.0434 26.1479 42.2945",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_49_231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4173 96.9178V65.5986C17.4173 65.0463 17.865 64.5986 18.4173 64.5986H33.9679L40.9366 71.5063V96.9178C40.9366 97.47 40.4889 97.9178 39.9366 97.9178H18.4173C17.865 97.9178 17.4173 97.47 17.4173 96.9178Z",
    fill: "#5C4691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9366 71.5063V96.9178C40.9366 97.47 40.4889 97.9178 39.9366 97.9178H18.4173C17.865 97.9178 17.4173 97.47 17.4173 96.9178V65.5986C17.4173 65.0463 17.865 64.5986 18.4173 64.5986H33.9679M40.9366 71.5063H34.9679C34.4157 71.5063 33.9679 71.0585 33.9679 70.5063V64.5986M40.9366 71.5063L33.9679 64.5986",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3171 83.2183V87.1181C22.3171 87.6704 22.7649 88.1181 23.3171 88.1181H35.0368C35.5891 88.1181 36.0368 87.6704 36.0368 87.1181V83.2183",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5305 75.0249C29.3353 74.8296 29.0187 74.8296 28.8234 75.0249L25.6415 78.2068C25.4462 78.4021 25.4462 78.7187 25.6415 78.914C25.8367 79.1092 26.1533 79.1092 26.3486 78.914L29.177 76.0855L32.0054 78.914C32.2007 79.1092 32.5173 79.1092 32.7125 78.914C32.9078 78.7187 32.9078 78.4021 32.7125 78.2068L29.5305 75.0249ZM29.677 86.1581L29.677 75.3784L28.677 75.3784L28.677 86.1581L29.677 86.1581Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_49_231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0299 92.1172C40.6435 92.9915 49.5127 97.1442 53.857 98.1458C55.2017 101.788 57.8522 107.088 54.625 107.525C50.5909 108.071 41.0469 105.776 36.7025 100.859C34.0476 97.8539 37.0131 91.0245 39.0299 92.1172Z",
    fill: "#5C4691"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_49_231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7329 88.6502C19.4806 89.5089 13.9546 93.0062 10.5829 93.9901C9.53933 97.568 8.0783 102.969 10.583 103.398C13.7138 103.935 18.7428 102.381 23.2994 97.8608C25.7444 95.4351 22.2981 87.5768 20.7329 88.6502Z",
    fill: "#5C4691"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_49_231",
    x: 16.9173,
    y: 64.0986,
    width: 30.5194,
    height: 40.3191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_49_231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_49_231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_49_231",
    x: 28.65,
    y: 90,
    width: 28.5115,
    height: 23.604,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_49_231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_49_231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_49_231",
    x: 9.2,
    y: 83.55,
    width: 22.95,
    height: 22.95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_49_231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_49_231",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFirst);
export default __webpack_public_path__ + "static/media/Upload_first.a12e6fe42d062278c5d958537d7f0d18.svg";
export { ForwardRef as ReactComponent };